import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { AssignmentEnum, type AssignmentFormValues } from "./Assignment.schema"

const commonFiedsConf = {
  [AssignmentEnum.UPP_ID]: { disabled: true },
  [AssignmentEnum.SECTOR_ID]: { disabled: true },
  [AssignmentEnum.ULTRA]: { disabled: true },
  [AssignmentEnum.ENTRY_DATE]: { disabled: true },
  [AssignmentEnum.CERP_CODE]: { disabled: true },
  [AssignmentEnum.CERP_BRANCH]: { disabled: true },
  [AssignmentEnum.NEGATIVE_SEGMENTATION]: { disabled: true },
  negativeSegmentationSection: { hide: true },
}

export const formRoleConf = {
  [ROLES.ADHERENT_HOLDER]: commonFiedsConf,
  [ROLES.ADHERENT_TEAM]: commonFiedsConf,
  [ROLES.ADMIN]: {},
} satisfies RoleStrategy<
  Partial<
    Record<
      keyof AssignmentFormValues | "negativeSegmentationSection",
      Record<string, unknown>
    >
  >
>
